import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigurationService } from '../../configuration.service';
import { EmailTypeConfig } from '../../dashboard-config.model';

@Component({
  selector: 'app-search-email-config',
  templateUrl: './search-email-config.component.html',
  styleUrls: ['./search-email-config.component.scss']
})
export class SearchEmailConfigComponent implements OnInit {
  dataSource = new MatTableDataSource<EmailTypeConfig>();
  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = ['transfer','emailType', 'sendingType', 'smtpid', 'username', 'password', 'port', 'reqssl',
  'frommailid',  'fromMailName','subject', 'templateType','fileName', 'emailCC', 'emailBCC', 'messageTemplate', 'isActive'];
  constructor(public dialog:MatDialog, public configService:ConfigurationService) { }

  ngOnInit(): void {
    this.allEmailType();
    this.configService.selecteEmailData =null;
  }

  allEmailType() {
    this.configService.emailConfigType(0).subscribe(data => {
       this.dataSource.data = data
    });
  }

  selectRow(row) {
    this.selection.toggle(row);
    this.configService.selecteEmailData = row;
    this.dialog.closeAll();
  }

  closedialog() {
    this.dialog.closeAll();
  }

}
